import { Box, Button, Tooltip } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DateRangeFilter from '../../../../components/Shared/DateRangeFilter/DateRangeFilter.tsx';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function ReportingToolbar({
  startDate,
  endDate,
  onApplyDateRange,
  onSync,
  isSyncing,
  eventsPending = 0,
  showSync = false,
  onExport,
  isExporting = false,
  exportDisabled = false,
  showExport = false,
  children,
}) {
  const styles = useTemplateSx();

  const syncTooltip =
    eventsPending > 0
      ? `${eventsPending} reporting event(s) pending — click to process now`
      : 'Process pending reporting events and refresh metrics';

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
      {onApplyDateRange ? (
        <DateRangeFilter
          onApply={onApplyDateRange}
          startDate={startDate}
          endDate={endDate}
        />
      ) : null}
      {showSync && onSync ? (
        <Tooltip title={syncTooltip} arrow placement="top">
          <span>
            <Button
              variant="outlined"
              size="small"
              startIcon={<SyncIcon fontSize="small" />}
              onClick={onSync}
              disabled={isSyncing}
              sx={styles.syncButton}
            >
              {isSyncing ? 'Syncing…' : eventsPending > 0 ? `Sync (${eventsPending})` : 'Sync'}
            </Button>
          </span>
        </Tooltip>
      ) : null}
      {showExport && onExport ? (
        <Button
          variant="contained"
          size="small"
          startIcon={<FileDownloadIcon fontSize="small" />}
          onClick={onExport}
          disabled={exportDisabled || isExporting}
          sx={styles.createButton}
        >
          {isExporting ? 'Exporting…' : 'Export CSV'}
        </Button>
      ) : null}
      {children}
    </Box>
  );
}
